import {
	reOrgConversionConstructionMaterialConstants
}from "./constants"
import actions from '../../actions'

const initialState =
{
	isSending      : false,
	isAuditSending : false,
	paged          : {},
	pagedAudit     : {},
	changed        : null
}

export default function (state = initialState, action){
	switch (action.type){
		case reOrgConversionConstructionMaterialConstants.GetPaged.REQUEST:
		case reOrgConversionConstructionMaterialConstants.GetPagedAll.REQUEST:
		case reOrgConversionConstructionMaterialConstants.Create.REQUEST:
		case reOrgConversionConstructionMaterialConstants.Delete.REQUEST:
		case reOrgConversionConstructionMaterialConstants.DeleteSelected.REQUEST:
		case reOrgConversionConstructionMaterialConstants.DeleteByFilter.REQUEST:
		case reOrgConversionConstructionMaterialConstants.Restore.REQUEST:
		case reOrgConversionConstructionMaterialConstants.Update.REQUEST:
		case reOrgConversionConstructionMaterialConstants.CreateFromFile.REQUEST:
		case reOrgConversionConstructionMaterialConstants.GetExampleFile.REQUEST:
			return {
				...state,
				isSending : true,
				changed   : null
			}
		case reOrgConversionConstructionMaterialConstants.GetPaged.FAILURE:
		case reOrgConversionConstructionMaterialConstants.GetPagedAll.FAILURE:
		case reOrgConversionConstructionMaterialConstants.Create.FAILURE:
		case reOrgConversionConstructionMaterialConstants.Delete.FAILURE:
		case reOrgConversionConstructionMaterialConstants.DeleteSelected.FAILURE:
		case reOrgConversionConstructionMaterialConstants.DeleteByFilter.FAILURE:
		case reOrgConversionConstructionMaterialConstants.Restore.FAILURE:
		case reOrgConversionConstructionMaterialConstants.Update.FAILURE:
		case reOrgConversionConstructionMaterialConstants.CreateFromFile.FAILURE:
		case reOrgConversionConstructionMaterialConstants.GetExampleFile.FAILURE:
			return {
				...state,
				isSending : false,
				error     : action.payload,
				changed   : null
			}
		case reOrgConversionConstructionMaterialConstants.GetPagedAudit.REQUEST:
			return {
				...state,
				isAuditSending: true
			}
		case reOrgConversionConstructionMaterialConstants.GetPagedAudit.FAILURE:
			return {
				...state,
				isAuditSending: false
			}
		case reOrgConversionConstructionMaterialConstants.GetPagedAudit.CLEAR:
			return {
				...state,
				pagedAudit     : {},
				isAuditSending : false
			}
		case reOrgConversionConstructionMaterialConstants.GetPagedAudit.SUCCESS:
			return {
				...state,
				isAuditSending : false,
				pagedAudit     : action.payload.result
			}
		case reOrgConversionConstructionMaterialConstants.GetPaged.SUCCESS:
		case reOrgConversionConstructionMaterialConstants.GetPagedAll.SUCCESS:
			return {
				...state,
				isSending : false,
				paged     : action.payload.result
			}
		case reOrgConversionConstructionMaterialConstants.GetExampleFile.SUCCESS:
			return {
				...state,
				isSending: false
			}
		case reOrgConversionConstructionMaterialConstants.Create.SUCCESS:
			return {
				...state,
				isSending : false,
				changed   : action.payload.result ? actions.create : actions.nochanges
			}
		case reOrgConversionConstructionMaterialConstants.CreateFromFile.SUCCESS:
			return {
				...state,
				isSending : false,
				changed   : action.payload.result ? actions.download : actions.nochanges
			}
		case reOrgConversionConstructionMaterialConstants.DeleteSelected.SUCCESS:
		case reOrgConversionConstructionMaterialConstants.DeleteByFilter.SUCCESS:
		case reOrgConversionConstructionMaterialConstants.Delete.SUCCESS:
			return {
				...state,
				isSending : false,
				changed   : action.payload.result ? actions.delete : actions.nochanges
			}
		case reOrgConversionConstructionMaterialConstants.Update.SUCCESS:
			return {
				...state,
				isSending : false,
				changed   : action.payload.result ? actions.update : actions.nochanges
			}
		case reOrgConversionConstructionMaterialConstants.Restore.SUCCESS:
			return {
				...state,
				isSending : false,
				changed   : action.payload.result ? actions.restore : actions.nochanges
			}
		case reOrgConversionConstructionMaterialConstants.CLEAR:
			return {
				...state,
				changed        : null,
				isSending      : false,
				isAuditSending : false,
				paged          : {},
				pagedAudit     : {}
			}
		default:
			return state
	}
}